export default __webpack_public_path__ + "static/media/map.9366a45f.png";